import { render, staticRenderFns } from "./HeaderDelivery.vue?vue&type=template&id=144e507d&scoped=true&"
import script from "./HeaderDelivery.vue?vue&type=script&lang=js&"
export * from "./HeaderDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e507d",
  null
  
)

export default component.exports